import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { AccountMode } from 'reducers/settings.reducer';
import LinksList from './LinksList.react';
import UserMenu from './UserMenu.react';

const DEFAULT_ACL: any = {};

const MenuAuthenticated = ({ currentUser, acl = DEFAULT_ACL }) => {
  const settings = useSelector((state) => {
    return state.settings;
  }) as any;

  const isProfessionalModeActive =
    settings.mode === AccountMode.Professional || false;
  const isAdmin = acl.admin || false;

  const linksLeft = [
    isProfessionalModeActive
      ? { path: '/accounts', title: 'Accounts' }
      : { path: '/portfolios', title: 'Portfolios' },
    ...(isAdmin ? [{ path: '/ledgers', title: 'Ledgers' }] : []),
  ];

  return (
    <>
      <LinksList links={linksLeft} />
      <UserMenu currentUser={currentUser} acl={acl} />
    </>
  );
};

MenuAuthenticated.propTypes = {
  currentUser: PropTypes.object.isRequired,
  acl: PropTypes.object,
};

export default MenuAuthenticated;
